import React from 'react';
import {FormControl, FormControlLabel, Radio, RadioGroup, Stack, Typography} from '@mui/material';
import {
    POLICY_OPTIONS
} from '../../../../components/prosemirror-editor/components/documentHeader/disclosureFieldOptions';

/**
 * Policy Selector Component
 * Compact radio button selector for disclosure policies with dynamic details
 */
const PolicySelector = ({selectedPolicy, onPolicyChange}) => {
    const handleChange = (value) => {
        onPolicyChange(value);
    };

    const selectedOption =
        POLICY_OPTIONS.find((o) => o.value === selectedPolicy) ?? POLICY_OPTIONS[0];

    return (
        <Stack spacing={1}>
            <Typography variant="body1" fontWeight="bold">
                Apply Disclosure Policy
            </Typography>

            <FormControl>
                <RadioGroup
                    row
                    value={selectedOption?.value ?? ''}
                    onChange={(e) => handleChange(e.target.value)}
                    sx={{
                        gap: 1,
                        '& .MuiFormControlLabel-root': {
                            m: 0,
                            px: 1.25,
                            py: 0.5,
                            borderRadius: 1,
                            border: '1px solid',
                            borderColor: 'divider',
                            transition: 'all 0.2s',
                            userSelect: 'none',
                        },
                        '& .MuiFormControlLabel-root:hover': {
                            borderColor: 'primary.main',
                            bgcolor: 'action.hover',
                        },
                        '& .MuiFormControlLabel-root.Mui-checked': {
                            borderColor: 'primary.main',
                            bgcolor: 'primary.lighter',
                        },
                        // Some MUI versions apply checked state to the label via aria-checked.
                        '& .MuiFormControlLabel-root[aria-checked="true"]': {
                            borderColor: 'primary.main',
                            bgcolor: 'primary.lighter',
                        },
                        '& .MuiRadio-root': {p: 0.5},
                    }}
                >
                    {POLICY_OPTIONS.slice(0, 2).map((option) => (
                        <FormControlLabel
                            key={option.value}
                            value={option.value}
                            control={<Radio/>}
                            label={<Typography variant="body2" fontWeight="bold">{option.label}</Typography>}
                        />
                    ))}
                </RadioGroup>
            </FormControl>

            <Stack>
                <Typography variant="caption" color="text.secondary" sx={{display: 'block', mb: 0.5}}>
                    Policy Details:
                </Typography>
                <Typography variant="body2">
                    {selectedOption?.description ?? 'Select a policy to see details.'}
                </Typography>
            </Stack>
        </Stack>
    );
};

export default PolicySelector;
